import {ApplicationStages, BuildType, EmploymentTypes, MortgageTypes} from "../../../models";
import {capitaliseWords} from "../../../assets/scripts/string-functions";
import SussdCoverNoteV2, {coverNoteV2Props} from "../../../config-files/mortgage/documents/SussdCoverNoteV2";
import useRates from "./useRates";
import SuitabilityLetter from "../../../config-files/mortgage/documents/SuitabilityLetter";
import {App} from "antd";
import {adminGiftCertificateSection} from "./uploads/verified-upload-sections/gift-certificate/section";
import SussdProofOfFunds from "../../../config-files/mortgage/documents/SussdProofOfFunds";
import {useMemo, useState} from "react";


function useAdminMortgageDocuments(mortgage) {
    const [messageList,setMessageList] = useState([])

    const app = App.useApp()
    const {getProductsForMortgage} = useRates()
    return useMemo(() => {
        return {
            sign: () => {
                return {
                    user: {
                        create: (() => {
                            const items = []
                            switch (mortgage.activeSubmission?.lenderCode) {
                                case 'avant':
                                    items.push({
                                        name: 'terms-of-business',
                                        overlay: false,
                                        folder: 'lender-documents',
                                    })
                                    if (mortgage.requirement.receivingGifts && mortgage.requirement.depositGifts > 0) {
                                        items.push({
                                            name: 'avant-gift-letter',
                                            overlay: true,
                                            folder: 'customer-docusign'
                                        })
                                    }
                                    break;
                                case 'ptsb':
                                    if (mortgage.mortgageType === MortgageTypes.REFINANCE) {
                                        items.push({
                                            name: 'mortgage-switcher-guide',
                                            overlay: false,
                                            folder: 'lender-documents',
                                        })
                                    } else {
                                        items.push({
                                            name: 'mortgage-guide',
                                            overlay: false,
                                            folder: 'lender-documents',
                                        })
                                    }
                                    items.push({
                                        name: 'variable-rate-policy-statement',
                                        overlay: false,
                                        folder: 'lender-documents',
                                    })
                                    items.push({
                                        name: 'terms-conditions',
                                        overlay: false,
                                        folder: 'lender-documents',
                                    })
                                    items.push({
                                        name: 'terms-of-business',
                                        overlay: false,
                                        folder: 'lender-documents',
                                    })
                                    items.push({
                                        name: 'data-protection-notice',
                                        overlay: false,
                                        folder: 'lender-documents',
                                    })
                                    items.push({
                                        name: 'data-protection-summary',
                                        overlay: false,
                                        folder: 'lender-documents',
                                    })
                                    break;
                                case 'ics':
                                    items.push({
                                        name: 'ics-mortgage-brochure',
                                        overlay: false,
                                        folder: 'lender-documents',
                                    })
                                    items.push({
                                        name: 'ics-application',
                                        overlay: true,
                                        folder: 'customer-docusign'
                                    })
                                    break
                                case 'haven':
                                    if (mortgage.mortgageType === MortgageTypes.REFINANCE) {
                                        items.push({
                                            name: 'guide-to-switching-your-mortgage',
                                            overlay: false,
                                            folder: 'lender-documents',
                                        })
                                    }
                                    // if (mortgage.requirement.receivingGifts && mortgage.requirement.depositGifts > 0){
                                    //     items.push({
                                    //         name:'haven-gift-letter',
                                    //         folder: 'downloads',
                                    //         overlay: true
                                    //     })
                                    // }
                                    items.push({
                                        name: 'home-loan-mortgage-general-and-regulatory-information',
                                        overlay: false,
                                        folder: 'lender-documents',
                                    })
                                    items.push({
                                        name: 'homeloan-conditions',
                                        overlay: false,
                                        folder: 'lender-documents',
                                    })
                                    items.push({
                                        name: 'terms-of-business',
                                        overlay: false,
                                        folder: 'lender-documents'
                                    })
                                    if (mortgage.requirement.lenderProduct?.toLowerCase()?.includes('green')) {
                                        items.push({
                                            name: 'green-mortgage-brochure',
                                            overlay: false,
                                            folder: 'lender-documents'
                                        })
                                    }
                                    break;
                                case 'boi':
                                    items.push({
                                        name: 'data-privacy-notice-august-2025',
                                        overlay: false,
                                        folder: 'lender-documents',
                                    })
                                    items.push({
                                        name: 'data-privacy-summary-august-2025',
                                        overlay: false,
                                        folder: 'lender-documents',
                                    })
                                    items.push({
                                        name: 'terms-of-business-2026',
                                        overlay: false,
                                        folder: 'lender-documents'
                                    })

                                    break;
                            }
                            return [
                                {
                                    name: 'terms-of-business',
                                    key: 'terms-of-business',
                                    overlay: false,
                                    private: false,
                                    sussd: true,
                                    folder: 'sussd-documents',
                                    generated: mortgage.UserMortgageDocuments.find(doc => doc.folder === 'sussd-documents' && doc.name === 'terms-of-business'),
                                }, {
                                    name: 'privacy-policy',
                                    key: 'privacy-policy',
                                    overlay: false,
                                    private: false,
                                    sussd: true,
                                    folder: 'sussd-documents',
                                    generated: mortgage.UserMortgageDocuments.find(doc => doc.folder === 'sussd-documents' && doc.name === 'privacy-policy'),
                                },
                                ...items.map(item => {
                                    return {
                                        ...item,
                                        key: item.name,
                                        private: false,
                                        generated: mortgage.UserMortgageDocuments.find(doc => doc.folder === item.folder && doc.name === item.name && doc.submissionID === mortgage.activeSubmission?.id),
                                    }
                                })
                            ]
                        })(),
                        //upload: mortgage.mortgageUploads.apply
                    },
                    admin: {
                        create: (() => {
                            const items = []

                            // 1. Lender Checklist
                            switch (mortgage.activeSubmission?.lenderCode) {
                                case 'avant':
                                    items.push({
                                        name: 'declaration-of-identity',
                                        overlay: true,
                                    })
                                    // items.push({
                                    //     name: 'broker-checklist',
                                    //     overlay: true,
                                    // })
                                    items.push({
                                        name: 'mortgage-application-document-upload-checklist',
                                        overlay: true,
                                    })
                                    items.push({
                                        name: 'application-cover-note',
                                        fill: true
                                    })
                                    break;
                                case 'boi': // Bank of Ireland

                                    items.push({
                                        name: 'document-checklist',
                                        overlay: true,
                                    })
                                    items.push({
                                        name: 'credit-intermediary-confirmations',
                                        overlay: true,
                                    })

                                    break;
                                case 'ics':
                                    items.push({
                                        name: 'documents-checklist',
                                        overlay: true
                                    })
                                    break;
                                case 'ptsb':
                                    items.push({
                                        name: 'mortgage-application-for-credit',
                                        overlay: true,

                                    })
                                    items.push({
                                        name: 'minimum-standards-checklist',
                                        overlay: true,

                                    })
                                    items.push({
                                        name: 'sight-of-original-declaration',
                                        overlay: true,

                                    })

                                    // if (mortgage.twoApplicants){
                                    //     items.push({
                                    //         name: 'cover-note-2-apps',
                                    //         overlay: true,
                                    //     })
                                    // }
                                    // else{
                                    //     items.push({
                                    //         name: 'cover-note-1-app',
                                    //         overlay: true,
                                    //     })
                                    // }

                                    break;
                                case 'haven':
                                    items.push({
                                        name: 'declaration-and-authorisations',
                                        overlay: true,

                                    })
                                    items.push({
                                        name: 'approval-in-principle-checklist',
                                        overlay: true,
                                    })
                                    if (mortgage.twoApplicants) {
                                        // items.push({
                                        //     name: 'cover-note-2-apps',
                                        //     overlay: true,
                                        // })
                                    }
                                    // else{
                                    //     items.push({
                                    //         name: 'cover-note-1-app',
                                    //         overlay: true,
                                    //     })
                                    // }
                                    break;
                            }
                            if (mortgage.activeSubmission?.lenderCode !== 'avant') {
                                if (mortgage.activeSubmission?.verifiedFiguresTest?.test) {
                                    items.push({
                                        name: 'cover-note',
                                        render: {
                                            name: 'cover-note',
                                            Component: SussdCoverNoteV2,
                                            props: coverNoteV2Props(mortgage, mortgage.activeSubmission?.verifiedFiguresTest?.test, mortgage.activeSubmission?.verifiedFiguresTest)
                                        }
                                    })
                                } else {
                                    const message = 'Won\'t generate cover note without verified figures test'
                                    if (!messageList.includes(message)){
                                        app.notification.error({message})
                                        setMessageList(prev => [...prev, message])
                                    }


                                }

                            }


                            let folder = 'submission-documents'
                            return items.map(item => {
                                return {
                                    ...item,
                                    key: item.name,
                                    folder,
                                    private: true,
                                    generated: mortgage.UserMortgageDocuments.find(doc => doc.folder === folder && doc.name === item.name),
                                }
                            })
                        })(),
                        upload: []
                    }

                }
            },
            preapproval: () => {
                // const userCreate = (() => {
                //
                //     const activeSubmission = mortgage.activeSubmission
                //
                //     const items = []
                //     if (!activeSubmission) {
                //         return items
                //     }
                //     // 1. Lender Checklist
                //     switch (activeSubmission?.lenderCode) {
                //         case 'avant':
                //
                //             if (mortgage.requirement.receivingGifts && mortgage.requirement.depositGifts > 0) {
                //                 items.push({
                //                     name: 'avant-gift-letter',
                //                     folder: 'downloads'
                //                 })
                //             }
                //             break;
                //         case 'ptsb':
                //
                //             if (mortgage.requirement.receivingGifts && mortgage.requirement.depositGifts > 0) {
                //                 items.push({
                //                     name: 'ptsb-gift-letter',
                //                     folder: 'downloads',
                //                     overlay: true
                //                 })
                //             }
                //             if (mortgage.properties[0]?.buildType === BuildType.SELFBUILD) {
                //                 items.push({
                //                     name: 'self-build-projected-costing',
                //                     folder: 'downloads'
                //                 }, {
                //                     name: 'certificate-of-inspection-statutory',
                //                     folder: 'downloads'
                //                 }, {
                //                     name: 'certificate-of-inspection-opt-out',
                //                     folder: 'downloads'
                //                 })
                //             }
                //             break;
                //         case 'haven':
                //             items.push({
                //                 name: 'interest-rate-application-form',
                //                 overlay: true,
                //                 folder: 'customer-docusign'
                //             })
                //             if (mortgage.requirement.receivingGifts && mortgage.requirement.depositGifts > 0) {
                //                 items.push({
                //                     name: 'haven-gift-letter',
                //                     folder: 'downloads',
                //                     overlay: true
                //                 })
                //             }
                //             let rateModel = mortgage.activeSubmission?.finalRateModel || mortgage.activeSubmission?.provisionalRateModel
                //             let loan = mortgage.activeSubmission?.finalLoan || mortgage.activeSubmission?.provisionalLoan || mortgage.requirement.loanRequired
                //             let fiveGrandAvailable = loan >= 250000 && !!rateModel.term && !rateModel?.conditions?.includes('BER B3 or better required') && !rateModel?.conditions?.includes('Green')
                //             let cashbackDocRequired = mortgage.mortgageType === MortgageTypes.REFINANCE || fiveGrandAvailable
                //
                //             if (cashbackDocRequired) {
                //                 items.push({
                //                     name: 'cashback-brochure',
                //                     overlay: false,
                //                     folder: 'lender-documents',
                //                 })
                //                 items.push({
                //                     name: 'cashback-form',
                //                     overlay: true,
                //                     folder: 'customer-docusign',
                //                 })
                //             }
                //
                //             break;
                //     }
                //     return items.map(item => {
                //         return {
                //             ...item,
                //             key: item.name + '/' + item.folder + '/' + activeSubmission?.id,
                //             private: false,
                //             generated: mortgage.UserMortgageDocuments.find(doc => doc.folder === item.folder && doc.name === item.name && doc.submissionID === activeSubmission?.id),
                //         }
                //     })
                // })()
                //const userCreate = customerPreApprovalDocumentsToCreate(mortgage)
                const userCreate = (() => {
                    const items = [
                        {
                            name: 'proof-of-funds',
                            folder: 'sussd-documents',
                            optional: true,
                            render: {
                                name: 'proof-of-funds',
                                Component: SussdProofOfFunds,
                                props: {
                                    applicationTitle: mortgage.applicationTitle,
                                    addressToPurchase: mortgage.property.address,
                                    addressee: `${mortgage.property.agentFirstName} ${mortgage.property.agentLastName}\n${mortgage.property.agentCompanyName}\n${mortgage.property.agentCompanyAddress}`,
                                    addresseeFirstName: mortgage.property.agentFirstName,
                                    lenderName: "Avant",
                                    applicationPossessive: mortgage.twoApplicants ? 'their' : mortgage.applicant1.isMale ? 'his' : 'her',
                                    applicationPreposition: mortgage.twoApplicants ? 'they' : mortgage.applicant1.isMale ? 'he' : 'she',
                                }
                            }
                        }
                    ]
                    switch (mortgage.activeSubmission?.lenderCode) {
                        case 'avant':

                            if (mortgage.requirement.receivingGifts && mortgage.requirement.depositGifts > 0) {
                                items.push({
                                    name: 'avant-gift-letter',
                                    folder: 'downloads',
                                    overlay: true,
                                    dataType: adminGiftCertificateSection
                                })
                            }
                            break;
                        case 'ptsb':

                            if (mortgage.requirement.receivingGifts && mortgage.requirement.depositGifts > 0) {
                                items.push({
                                    name: 'ptsb-gift-letter',
                                    folder: 'downloads',
                                    overlay: true,
                                    dataType: adminGiftCertificateSection
                                })
                            }
                            if (mortgage.properties[0]?.buildType === BuildType.SELFBUILD) {
                                items.push({
                                    name: 'self-build-projected-costing',
                                    folder: 'downloads'
                                }, {
                                    name: 'certificate-of-inspection-statutory',
                                    folder: 'downloads'
                                }, {
                                    name: 'certificate-of-inspection-opt-out',
                                    folder: 'downloads'
                                })
                            }
                            break;
                        case 'haven':
                            items.push({
                                name: 'interest-rate-application-form',
                                overlay: true,
                                folder: 'customer-docusign'
                            })
                            if (mortgage.requirement.receivingGifts && mortgage.requirement.depositGifts > 0) {
                                items.push({
                                    name: 'haven-gift-letter',
                                    folder: 'downloads',
                                    overlay: true,
                                    dataType: adminGiftCertificateSection
                                })
                            }
                            let rateModel = mortgage.activeSubmission?.finalRateModel || mortgage.activeSubmission?.provisionalRateModel
                            let loan = mortgage.activeSubmission?.finalLoan || mortgage.activeSubmission?.provisionalLoan || mortgage.requirement.loanRequired
                            let fiveGrandAvailable = rateModel && loan >= 250000 && !!rateModel.term && !rateModel?.conditions?.includes('BER B3 or better required') && !rateModel?.conditions?.includes('Green')
                            let cashbackDocRequired = mortgage.mortgageType === MortgageTypes.REFINANCE || fiveGrandAvailable

                            if (cashbackDocRequired) {
                                // if (!(mortgage.requirement.lenderProduct || '').toLowerCase().includes('green')) {
                                items.push({
                                    name: 'cashback-brochure',
                                    overlay: false,
                                    folder: 'lender-documents',
                                })
                                items.push({
                                    name: 'cashback-form',
                                    overlay: true,
                                    folder: 'customer-docusign',
                                })
                            }

                            break;
                        case 'boi':
                            if (mortgage.requirement.receivingGifts && mortgage.requirement.depositGifts > 0) {
                                items.push({
                                    name: 'boi-gift-template',
                                    fill: true,
                                    folder: 'downloads'
                                })
                            }
                            break
                    }
                    return items.map(item => {
                        return {
                            ...item,
                            key: item.name + '/' + item.folder + '/' + mortgage.activeSubmission?.id,
                            private: false,
                            generated: mortgage.UserMortgageDocuments.find(doc => doc.folder === item.folder && doc.name === item.name && doc.submissionID === mortgage.activeSubmission?.id),
                        }
                    })
                })()

                return {
                    user: {
                        create: userCreate,
                        //  upload: mortgage.uploadSections.filter(it=>it.stage === 'PREAPPROVAL' && it.isActive)
                    },
                    admin: {
                        create: (() => {
                            if (!mortgage.activeSubmission) return []
                            const items = []

                            // 1. Lender Checklist
                            switch (mortgage.activeSubmission?.lenderCode) {
                                case 'avant':
                                    items.push({
                                        name: 'loan-offer-details',
                                        overlay: true
                                    })
                                    break;
                                case 'ics':
                                    items.push({
                                        name: 'loan-offer-checklist',
                                        overlay: true
                                    })
                                    break;
                                case 'ptsb':
                                    items.push({
                                        name: 'loan-offer-confirmation',
                                        overlay: true
                                    })

                                    items.push({
                                        name: 'amendment-request-form',
                                        overlay: true,
                                        optional: true
                                    })
                                    break;
                                case 'haven':
                                    items.push({
                                        name: 'loan-offer-checklist',
                                        overlay: true
                                    })
                                    break;
                                case 'boi':
                                    items.push({
                                        name: 'change-in-proposal-requirements',
                                        overlay: true
                                    })

                                    break;
                            }

                            let folder = 'submission-documents'
                            return items.map(item => {
                                return {
                                    ...item,
                                    key: item.name,
                                    folder,
                                    private: true,
                                    generated: mortgage.UserMortgageDocuments.find(doc => doc.folder === folder && doc.name === item.name),
                                }
                            })
                        })(),
                        upload: (() => {
                            const docs = userCreate.filter(it => ['customer-docusign', 'docusign'].includes(it.folder))
                            return docs.map(doc => ({
                                name: doc.name,
                                section: doc.name,
                                title: capitaliseWords(doc.name.replace(/-/g, ' ')),
                                children: '',
                                stage: ApplicationStages.PREAPPROVAL,
                                upload: true
                            })).map(item => ({
                                ...item,
                                key: item.name,
                                private: false,
                                folder: 'submission-documents',
                                uploaded: mortgage.UserMortgageDocuments.find(doc => doc.folder === 'submission-documents' && doc.name === item.name),
                            }))
                            return []
                            // const list = [{
                            //     name: 'insurance-transcript',
                            //     folder: 'insurance-documents',
                            //     stage: ApplicationStages.PREAPPROVAL,
                            //     uploaded: mortgage.UserMortgageDocuments.find(it => it.name === 'insurance-transcript' && it.folder === ApplicationStages.PREAPPROVAL)
                            // }]
                            //TODO : should also be the docusigned documents from create list
                            //return list
                        })()

                    }

                }
            },
            approval: () => {
                const userCreate = (() => {
                    const items = []
                    const activeSubmission = mortgage.activeSubmission
                    // 1. Lender Checklist
                    if (!activeSubmission) {
                        return items
                    }
                    switch (activeSubmission?.lenderCode) {
                        case 'avant':
                            items.push({
                                name: 'direct-debit-mandate',
                                fill: true,
                                folder: 'downloads'
                            })
                            let loan = mortgage.activeSubmission?.finalLoan || mortgage.activeSubmission?.provisionalLoan || mortgage.requirement.loanRequired
                            if (loan < 1000000) {
                                items.push({
                                    folder: 'customer-docusign',
                                    name: 'cashback-application-form'
                                })
                            }
                            break;
                        case 'boi':
                            items.push({
                                name: 'direct-debit-mandate',
                                overlay: true,
                                folder: 'downloads'
                            })
                            break;
                        case 'ics':
                            items.push({
                                name: 'ics-dd-mandate',
                                overlay: true,
                                folder: 'downloads'
                            })
                            break
                        case 'ptsb':
                            items.push({
                                name: 'direct-debit-mandate',
                                overlay: true,
                                folder: 'customer-docusign'
                            })
                            break;
                        case 'haven':
                            items.push({
                                name: 'change-of-correspondence-address',
                                overlay: true,
                                folder: 'downloads',
                            })
                            items.push({
                                name: 'deed-of-assignment',
                                overlay: true,
                                folder: 'downloads',
                            })
                            items.push({
                                name: 'direct-debit-mandate',
                                overlay: true,
                                folder: 'customer-docusign',
                            })

                            break;
                    }
                    return items.map(item => {
                        return {
                            ...item,
                            key: item.name,
                            private: false,
                            generated: mortgage.UserMortgageDocuments.find(doc => doc.folder === item.folder && doc.name === item.name && doc.submissionID === activeSubmission?.id),
                        }
                    })
                })()
                const adminCreate = (() => {
                    const rates = getProductsForMortgage(mortgage)

                    const items = []
                    let folder = 'submission-documents'
                    // 1. Lender Checklist
                    switch (mortgage.activeSubmission?.lenderCode) {
                        case 'avant':
                            // home insurance if not an apartment

                            // direct -debit mandate

                            // mortgage protection policy certificate


                            break;
                        case 'ptsb':
                            // items.push({
                            //     name: 'direct-debit-mandate',
                            //     folder: 'customer-docusign',
                            //     overlay: true
                            // })
                            let selfEmployed = []
                            let employed = []
                            mortgage.applicant1.employmentIncome.forEach(it => {
                                if (it.employmentType === EmploymentTypes.EMPLOYED) {
                                    employed.push(it)
                                }
                                if (it.employmentType === EmploymentTypes.SELFEMPLOYED) {
                                    selfEmployed.push(it)
                                }
                            })
                            if (mortgage.twoApplicants) {
                                mortgage.applicant2.employmentIncome.forEach(it => {
                                    if (it.employmentType === EmploymentTypes.EMPLOYED) {
                                        employed.push(it)
                                    }
                                    if (it.employmentType === EmploymentTypes.SELFEMPLOYED) {
                                        selfEmployed.push(it)
                                    }
                                })
                            }
                            if (employed.length > 0) {
                                items.push({
                                    name: 'pre-drawdown-paye',
                                    folder: 'customer-docusign',
                                    overlay: true
                                })
                            }
                            if (selfEmployed.length > 0) {
                                items.push({
                                    name: 'pre-drawdown-self-employed',
                                    folder: 'customer-docusign',
                                    overlay: true
                                })
                            }

                            break;
                        case 'haven':
                            items.push({
                                name: 'request-for-amended-offer',
                                folder: 'submission-documents',
                                overlay: true
                            })
                    }
                    items.push(
                        {
                            name: 'statement-of-suitability',
                            folder: 'customer-docusign',

                            render: {
                                Component: SuitabilityLetter,
                                props: {mortgage, keyName: 1, rates},
                                name: 'statement-of-suitability'
                            }
                        }
                    )


                    return items.map(item => {
                        let folder = item.folder ? item.folder : folder
                        let isPrivate = item.private ? item.private : true
                        return {
                            ...item,
                            key: item.name,
                            folder,
                            private: isPrivate,
                            generated: mortgage.UserMortgageDocuments.find(doc => doc.folder === folder && doc.name === item.name && doc.submissionID === mortgage.activeSubmission?.id),
                        }
                    })
                })()
                const adminUpload = (() => {
                    let docs = userCreate.filter(it => ['docusign', 'customer-docusign'].includes(it.folder)).map(it => ({
                        ...it,
                        name: 'signed-' + it.name,
                        folder: 'submission-documents'
                    }))
                    if (mortgage.requirement.hasOwnMPI) {
                        if (mortgage.requirement.mpiShortfallLetterRequired) {
                            docs.push({
                                name: 'existing-mpi-shortfall-letter',
                                folder: 'submission-documents',
                            })
                        }
                    } else {
                        docs.push({
                            name: 'mortgage-protection-policy-cert',
                            folder: 'submission-documents',
                        })
                    }

                    // docs.push({
                    //     name: 'statement-of-suitability',
                    //     folder: 'submission-documents',
                    // })

                    adminCreate.forEach(doc => {
                        if (['docusign', 'customer-docusign'].includes(doc.folder) && doc.generated) {
                            docs.push({
                                name: 'signed-' + doc.name,
                                folder: 'submission-documents',
                            })
                        }
                    })

                    return docs.map(doc => ({
                        name: doc.name,
                        section: doc.name,
                        title: capitaliseWords(doc.name.replace(/-/g, ' ')),
                        children: '',
                        stage: ApplicationStages.APPROVAL,
                        upload: true,
                        folder: doc.folder,
                    })).map(item => ({
                        ...item,
                        key: item.name,
                        private: true,
                        uploaded: mortgage.UserMortgageDocuments.find(doc => doc.folder === 'submission-documents' && doc.name === item.name && doc.submissionID === mortgage.activeSubmission?.id),
                    }))
                })()
                return {
                    user: {
                        create: userCreate,
                        //upload: mortgage.uploadSections.filter(it=>it.stage === 'APPROVAL' && it.isActive)
                    },
                    admin: {
                        create: adminCreate,
                        upload: adminUpload
                    }

                }
            }
        }
    }, [mortgage])

}

export default useAdminMortgageDocuments;